import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import config from "./config";
import router from './router'
import toast from './toast'

Vue.mixin({
    mixins: [router, toast,config],
    data() {
        return {

        };
    },
    computed: {
        ...mapState(["userInfo", "token",'hasSearch','pageName']),
    },
    created() {},
    methods: {
        ...mapMutations(["setUserInfo", "clearUser",'sethasSearch']),
        // getUserInfo: function() {
        //     this.$post('User/userInfo', {
        //         token: true,
        //     }).then(res => {
        //         if (res.code == 1) {
        //             res.data.password = '*******'
        //             this.setUserInfo(res.data);
        //             localStorage.setItem('user', JSON.stringify(res.data));
        //         }
        //     }).finally(() => {})
        // }

    },

});